module.exports = __webpack_public_path__ + "img/galeria-aquario-2.6d1318c5.jpg";